import React from 'react';
import styles from './HomeCard.module.scss';
import { getTranslation } from '../../../utils/translation';
import CardIcon from './CardIcon/CardIcon';

export default function HomeCard(props) {
    const { isLink, actionElement } = props;

    return (
        <div className={styles.wrapper}>
            {props.disabled && (
                <div className={styles.comingSoon} onClick={event => event.stopPropagation()}>
                    {getTranslation('comingSoon')}
                </div>
            )}
            <div className={`${styles.card} ${isLink ? styles.link : ''}`}>
                <CardIcon iconName={props.iconName} className={styles.cardIcon} />
                <p className={styles.cardTitle}>{props.title}</p>
                {actionElement}
            </div>
        </div>
    );
}
